import { createThunk, model, Model } from 'mst-collection';
import { getParent } from 'mobx-state-tree';

import { Api, ITutorialSubtitleResponse } from '@api';
import { LanguageCodesEnum } from '@constants';
import type { Tutorial } from './TutorialModel';

type LanguageCodeRecordType = Record<
  LanguageCodesEnum,
  null | ITutorialSubtitleResponse[]
>;

export class TutorialSubtitles
  extends Model({})
  implements LanguageCodeRecordType
{
  [LanguageCodesEnum.En] = null as null | ITutorialSubtitleResponse[];
  [LanguageCodesEnum.Fr] = null as null | ITutorialSubtitleResponse[];
  [LanguageCodesEnum.De] = null as null | ITutorialSubtitleResponse[];
  [LanguageCodesEnum.It] = null as null | ITutorialSubtitleResponse[];
  [LanguageCodesEnum.Pt] = null as null | ITutorialSubtitleResponse[];
  [LanguageCodesEnum.Es] = null as null | ITutorialSubtitleResponse[];

  private _setSubtitlesForLanguage(
    subtitles: ITutorialSubtitleResponse[],
    language: LanguageCodesEnum,
  ) {
    this[language] = subtitles;
  }

  fetch = createThunk((language: LanguageCodesEnum) => {
    return async function fetchSubtitles(this: TutorialSubtitles) {
      if (this[language]) {
        return;
      }

      const tutorial = getParent<Tutorial>(this);

      const res = await Api.Hub.getSubtitles({
        id: tutorial.id,
        language,
      });

      this._setSubtitlesForLanguage(res.data.subtitles, language);
    };
  });
}

export const TutorialSubtitlesModel = model(TutorialSubtitles);
